/**
 * Labstep
 *
 * @module components/Layout/FullPageError
 * @desc Generic Component showing full page error
 */

import { UserActionSignoutContainer } from 'labstep-web/components/User/Action/Signout';
import type React from 'react';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { LayoutFullPageErrorProps } from './types';

export const labstepMaintenanceError = (
  <Image centered src="/img/error/maintenance.svg" />
);

export const LayoutFullPageError: React.FC<
  LayoutFullPageErrorProps
> = ({ message, showSignout }) => (
  <div className={styles.container}>
    {labstepMaintenanceError}
    <p>{message}</p>
    {showSignout && (
      <div>
        <UserActionSignoutContainer skipApi />
      </div>
    )}
  </div>
);

LayoutFullPageError.defaultProps = {
  message:
    'Labstep is going through some features enhancement. Please refresh your page.',
};
